@if (internalPortal === false) {
  <footer>
    @if (footerHtml) {
      <div class="grid-container partner-footer" [innerHTML]="footerHtml"></div>
    }
    <div class="grid-container text-center" [class.partner-footer]="!footerHtml" [innerHTML]="'footer.partner' | translate: {'logo': '<img src=\'gfx/co2online_fuss_01.png\' alt=\'www.co2online.de\'>'}"></div>
  </footer>
}
